/**
 * Resolves a CSS custom property to its concrete value off a given element.
 *
 * Useful for canvas-based libraries (e.g. ECharts) that can't read `var(--x)`
 * colors themselves. Read off an element *inside* the themed scope (typically a
 * component's host) rather than `document.documentElement` — custom properties
 * inherit, so this picks up theme vars even when they're set on a wrapper.
 */
export function resolveCssVar(host: HTMLElement, name: string): string {
  return getComputedStyle(host).getPropertyValue(name).trim();
}

export function cssVarResolver(host: HTMLElement): (name: string) => string {
  return (name) => resolveCssVar(host, name);
}

/** `#rrggbb` → `rgba(r, g, b, alpha)`. */
export function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
